import React from "react";
import {
  FlexPresetConflict,
  PRESET_CONFLICT_FIX_HINT,
  presetConflictMessage,
} from "./flexPresetConflicts";

/** ENG-1927: inline list of cross-schedule preset conflicts (fleet sites). */
export const FlexPresetConflictsNotice = ({
  conflicts,
}: {
  conflicts: FlexPresetConflict[];
}) => {
  if (conflicts.length === 0) {
    return null;
  }
  return (
    <div
      role="alert"
      data-testid="flex-preset-conflicts"
      className="border border-red-300 bg-red-50 rounded-[6px] p-[12px] mb-[16px] max-w-[1500px]"
    >
      <p className="font-mulish text-[15px] font-black text-red-700 pb-[6px]">
        A camera can only run one preset at a time on this site
      </p>
      <ul className="list-disc pl-[20px] font-mulish text-[14px] text-red-700">
        {conflicts.map((conflict) => (
          <li
            key={`${conflict.cameraId}-${conflict.scheduleId}-${conflict.otherScheduleId}`}
          >
            {presetConflictMessage(conflict)}
          </li>
        ))}
      </ul>
      <p className="font-mulish text-[14px] text-red-700 pt-[6px]">
        {PRESET_CONFLICT_FIX_HINT}
      </p>
    </div>
  );
};
